export const serverUrl = 'https://baws.in/';

// Use the local pdfjs viewer since it's now in the public folder.
export const pdfjsUrl = '/pdfjs/web/viewer.html';

export const booksServerUrl = 'https://assets.studyring.org/assets/books';
export var searchHistory = new Map();
export const key_searchPageUrl = 'searchPageUrl';
export var key_bookUrl = 'bookUrl';
export var bookHistory = new Map();
bookHistory.set(key_bookUrl, {
  shortUrl: 'https://www.baws.in/books/baws/EN/Volume_01/pdf/37',
  longUrl:
    'https://assets.studyring.org/assets/books/baws/EN/Volume_01.pdf#page=38',
});
